import request from '@/utils/request'

/**
 * 查询主分类列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryMainCategory(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.queryMainCategory',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加主分类
 * @param {Object} data 分类数据
 * @returns {Promise} Promise对象
 */
export function saveMainCategory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.saveMainCategory',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新主分类
 * @param {Object} data 分类数据
 * @returns {Promise} Promise对象
 */
export function updateMainCategory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.updateMainCategory',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除主分类
 * @param {Object} data 分类数据
 * @returns {Promise} Promise对象
 */
export function deleteMainCategory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.deleteMainCategory',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}